import { Navigate } from 'react-router-dom';
import { routes } from '@platform/core/lib/routes';
import { RecordPage } from '@platform/engine/form/RecordPage';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';

/** П'ятий сегмент `/:group/:module/:entity/:id/:tab` (ADR-028): вкладка запису; без запису (подання) — список того самого подання. */
export function RecordTabRoute() {
  const { module, rt, id, view } = useWorkspaceParams();
  if (!rt) return <Navigate to={routes.module(module)} replace />;
  return id ? <RecordPage /> : <Navigate to={routes.list(module, rt, view)} replace />;
}
